import { render, staticRenderFns } from "./Myscreening.vue?vue&type=template&id=6b43d8aa&scoped=true&"
import script from "./Myscreening.vue?vue&type=script&lang=js&"
export * from "./Myscreening.vue?vue&type=script&lang=js&"
import style0 from "./Myscreening.vue?vue&type=style&index=0&id=6b43d8aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b43d8aa",
  null
  
)

export default component.exports